export const PERMISSIONS = {
  DASHBOARD_VIEW: 'dashboard.view',
  DASHBOARD_REVENUE_ANALYTICS: 'dashboard.revenue_analytics',
  DASHBOARD_ADMISSION_FUNNEL: 'dashboard.admission_funnel',
  DASHBOARD_COLLEGE_ANALYTICS: 'dashboard.college_analytics',
  DASHBOARD_COURSE_ANALYTICS: 'dashboard.course_analytics',
  DASHBOARD_ADMISSION_INTELLIGENCE: 'dashboard.admission_intelligence',
  DASHBOARD_GEOGRAPHIC_ORIGIN: 'dashboard.geographic_origin',
  DASHBOARD_PEAK_TIMINGS: 'dashboard.peak_timings',
  DASHBOARD_DEVICE_USAGE: 'dashboard.device_usage',
  DASHBOARD_ACTIVITY_FEED: 'dashboard.activity_feed',
  STATS_REVENUE: 'stats.revenue',
  STATS_ADMISSIONS: 'stats.admissions',
  STATS_STUDENTS: 'stats.students',
  STATS_PAYMENTS: 'stats.payments',
  STATS_TICKETS: 'stats.tickets',
  ADMISSIONS_VIEW: 'admissions.view',
  ADMISSIONS_EDIT: 'admissions.edit',
  ADMISSIONS_EXPORT: 'admissions.export',
  STUDENTS_VIEW: 'students.view',
  INSTITUTIONS_VIEW: 'institutions.view',
  INSTITUTIONS_CREATE: 'institutions.create',
  INSTITUTIONS_EDIT: 'institutions.edit',
  LINKED_ACCOUNTS_VIEW: 'linked_accounts.view',
  LINKED_ACCOUNTS_EDIT: 'linked_accounts.edit',
  COURSES_VIEW: 'courses.view',
  COURSES_CREATE: 'courses.create',
  COURSES_EDIT: 'courses.edit',
  COURSES_DELETE: 'courses.delete',
  COURSE_MANAGEMENT_VIEW: 'course_management.view',
  COURSE_MANAGEMENT_EDIT: 'course_management.edit',
  SETTLEMENTS_VIEW: 'settlements.view',
  SETTLEMENTS_REFRESH: 'settlements.refresh',
  SUPPORT_VIEW: 'support.view',
  LOGS_VIEW: 'logs.view',
  USER_MANAGEMENT_VIEW: 'user_management.view',
  SETTINGS_VIEW: 'settings.view',
  SETTINGS_EDIT: 'settings.edit',
  ADMINS_MANAGE: 'admins.manage',
};

export const ALL_PERMISSIONS = Object.values(PERMISSIONS);

export const PERMISSION_LABELS = {
  [PERMISSIONS.DASHBOARD_VIEW]: 'View dashboard',
  [PERMISSIONS.DASHBOARD_REVENUE_ANALYTICS]: 'Dashboard revenue analytics',
  [PERMISSIONS.DASHBOARD_ADMISSION_FUNNEL]: 'Dashboard admission funnel',
  [PERMISSIONS.DASHBOARD_COLLEGE_ANALYTICS]: 'Dashboard institution analytics',
  [PERMISSIONS.DASHBOARD_COURSE_ANALYTICS]: 'Dashboard course analytics',
  [PERMISSIONS.DASHBOARD_ADMISSION_INTELLIGENCE]: 'Dashboard admission intelligence',
  [PERMISSIONS.DASHBOARD_GEOGRAPHIC_ORIGIN]: 'Dashboard geographic origin',
  [PERMISSIONS.DASHBOARD_PEAK_TIMINGS]: 'Dashboard peak timings',
  [PERMISSIONS.DASHBOARD_DEVICE_USAGE]: 'Dashboard device usage',
  [PERMISSIONS.DASHBOARD_ACTIVITY_FEED]: 'Dashboard activity feed',
  [PERMISSIONS.STATS_REVENUE]: 'Revenue stat card',
  [PERMISSIONS.STATS_ADMISSIONS]: 'Admissions stat card',
  [PERMISSIONS.STATS_STUDENTS]: 'Students stat card',
  [PERMISSIONS.STATS_PAYMENTS]: 'Payments stat card',
  [PERMISSIONS.STATS_TICKETS]: 'Tickets stat card',
  [PERMISSIONS.ADMISSIONS_VIEW]: 'View admissions',
  [PERMISSIONS.ADMISSIONS_EDIT]: 'Update admission status',
  [PERMISSIONS.ADMISSIONS_EXPORT]: 'Export admissions',
  [PERMISSIONS.STUDENTS_VIEW]: 'View students',
  [PERMISSIONS.INSTITUTIONS_VIEW]: 'View institutions',
  [PERMISSIONS.INSTITUTIONS_CREATE]: 'Create institutions',
  [PERMISSIONS.INSTITUTIONS_EDIT]: 'Edit institutions',
  [PERMISSIONS.LINKED_ACCOUNTS_VIEW]: 'View linked accounts',
  [PERMISSIONS.LINKED_ACCOUNTS_EDIT]: 'Edit linked accounts',
  [PERMISSIONS.COURSES_VIEW]: 'View courses',
  [PERMISSIONS.COURSES_CREATE]: 'Create courses/programmes',
  [PERMISSIONS.COURSES_EDIT]: 'Edit courses',
  [PERMISSIONS.COURSES_DELETE]: 'Delete courses',
  [PERMISSIONS.COURSE_MANAGEMENT_VIEW]: 'View course management',
  [PERMISSIONS.COURSE_MANAGEMENT_EDIT]: 'Edit remaining seats',
  [PERMISSIONS.SETTLEMENTS_VIEW]: 'View settlements',
  [PERMISSIONS.SETTLEMENTS_REFRESH]: 'Refresh settlements',
  [PERMISSIONS.SUPPORT_VIEW]: 'View support desk',
  [PERMISSIONS.LOGS_VIEW]: 'View logs',
  [PERMISSIONS.USER_MANAGEMENT_VIEW]: 'View user management',
  [PERMISSIONS.SETTINGS_VIEW]: 'View settings',
  [PERMISSIONS.SETTINGS_EDIT]: 'Edit platform settings',
  [PERMISSIONS.ADMINS_MANAGE]: 'Create/edit admin users',
};

export const hasPermission = (user, permission) => {
  if (!permission) return true;
  return Array.isArray(user?.permissions) && user.permissions.includes(permission);
};

export const hasAnyPermission = (user, permissions = []) => permissions.some((permission) => hasPermission(user, permission));

export const PERMISSION_GROUPS = [
  {
    title: 'Pages',
    permissions: [
      PERMISSIONS.DASHBOARD_VIEW,
      PERMISSIONS.ADMISSIONS_VIEW,
      PERMISSIONS.ADMISSIONS_EDIT,
      PERMISSIONS.STUDENTS_VIEW,
      PERMISSIONS.INSTITUTIONS_VIEW,
      PERMISSIONS.LINKED_ACCOUNTS_VIEW,
      PERMISSIONS.COURSES_VIEW,
      PERMISSIONS.COURSE_MANAGEMENT_VIEW,
      PERMISSIONS.SETTLEMENTS_VIEW,
      PERMISSIONS.SUPPORT_VIEW,
      PERMISSIONS.LOGS_VIEW,
      PERMISSIONS.USER_MANAGEMENT_VIEW,
      PERMISSIONS.SETTINGS_VIEW,
    ],
  },
  {
    title: 'Dashboard Features',
    permissions: [
      PERMISSIONS.STATS_REVENUE,
      PERMISSIONS.STATS_ADMISSIONS,
      PERMISSIONS.STATS_STUDENTS,
      PERMISSIONS.STATS_PAYMENTS,
      PERMISSIONS.STATS_TICKETS,
      PERMISSIONS.DASHBOARD_REVENUE_ANALYTICS,
      PERMISSIONS.DASHBOARD_ADMISSION_FUNNEL,
      PERMISSIONS.DASHBOARD_COLLEGE_ANALYTICS,
      PERMISSIONS.DASHBOARD_COURSE_ANALYTICS,
      PERMISSIONS.DASHBOARD_ADMISSION_INTELLIGENCE,
      PERMISSIONS.DASHBOARD_GEOGRAPHIC_ORIGIN,
      PERMISSIONS.DASHBOARD_PEAK_TIMINGS,
      PERMISSIONS.DASHBOARD_DEVICE_USAGE,
      PERMISSIONS.DASHBOARD_ACTIVITY_FEED,
    ],
  },
  {
    title: 'Page Actions',
    permissions: [
      PERMISSIONS.ADMISSIONS_EXPORT,
      PERMISSIONS.INSTITUTIONS_CREATE,
      PERMISSIONS.INSTITUTIONS_EDIT,
      PERMISSIONS.LINKED_ACCOUNTS_EDIT,
      PERMISSIONS.COURSES_CREATE,
      PERMISSIONS.COURSES_EDIT,
      PERMISSIONS.COURSES_DELETE,
      PERMISSIONS.COURSE_MANAGEMENT_EDIT,
      PERMISSIONS.SETTLEMENTS_REFRESH,
      PERMISSIONS.SETTINGS_EDIT,
      PERMISSIONS.ADMINS_MANAGE,
    ],
  },
];
